import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=3e7e4202"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7e4202')) {
      api.createRecord('3e7e4202', component.options)
    } else {
      api.reload('3e7e4202', component.options)
    }
    module.hot.accept("./MiniCart.vue?vue&type=template&id=3e7e4202", function () {
      api.rerender('3e7e4202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MiniCart.vue"
export default component.exports